import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import MarketingPages from './pages/MarketingPages';
import CreateMarketingPage from './pages/CreateMarketingPage';

function App() {
  return (
    <Router>
      <div className="App">
        <main className="content">
          <Routes>
            <Route path="/" element={<MarketingPages />} />
            <Route path="/marketing" element={<MarketingPages />} />
            <Route path="/marketing/create" element={<CreateMarketingPage />} />
            <Route path="/marketing/edit/:id" element={<CreateMarketingPage />} />
          </Routes>
        </main>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable={false}
          pauseOnHover={false}
          theme="light"
          transition={Slide}
        />
      </div>
    </Router>
  );
}

export default App;
